import { Action } from '../actions/fuelReport';

const defaultState = {
  isPosting: false,
  fuelsPosted: false,
};

export default function fuelReportReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Fuels.ReportReset:
      return {
        ...state,
        fuelsPosted: undefined,
      };

    case Action.Fuels.ReportPending:
      return {
        ...state,
        isPosting: true,
        fuelsPosted: undefined,
      };

    case Action.Fuels.ReportCompleted:
      return {
        ...state,
        isPosting: false,
        fuelsPosted: true,
        pointsAwarded: body?.pointsAwarded,
      };

    case Action.Fuels.ReportFailed:
      return {
        ...state,
        isPosting: false,
        fuelsPosted: undefined,
        error: (body?.error?.message) || undefined,
      };

    default:
      return state;
  }
}
